import {trig} from './trig.js';
import {doc} from './documentation.js';
import {lazy} from './lang.js';

doc(
    "once",
    {
        "fn": "Function to run once",
        "when": "When to run",
    },
    "Runs the function once, after a certain number of triggers (default of 0)"
);
export const once = (fn, num=0) => {
    let counter=0;
    return (...args) => {
        let stepData = args[0];
        if (stepData  && counter++ === lazy(num, ...args)) {
            return lazy(fn, ...args);
        }
        return trig(args);
    };
};
